import { Box, Divider, SxProps, Typography } from "@mui/material";
import { ReactNode } from "react";
import { Flex } from "~/components/Flex";

type SectionHeadingProps = {
  heading: string;
  dividerContent?: ReactNode;
  sx?: SxProps;
  id?: string;
  level?: "h2" | "h3";
};

export const SectionHeading = ({
  heading,
  dividerContent,
  sx,
  id,
  level = "h2",
}: SectionHeadingProps) => {
  return (
    <Flex
      center
      gap={3}
      my={2}
      className="section-header"
      sx={{ ...sx }}
      id={id}
    >
      <Typography
        component={level}
        sx={{
          fontSize: 24,
          fontWeight: 700,
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        {heading}
      </Typography>
      <Box width={1}>
        <Divider
          textAlign="right"
          sx={{ "&::before": { width: "100%" }, "&::after": { width: 0 } }}
        >
          {dividerContent}
        </Divider>
      </Box>
    </Flex>
  );
};
